import { HTMLProps } from 'react';
import { Pressable } from 'react-native';
import { DropdownIcon } from '../../Icons/DropdownIcon';
import { useTheme } from '../../lib/useTheme';
import { cn } from '../../lib/utils';
import { Heading } from '../Heading/Heading';

type HeaderButtonProps = {
  title: string;
  className?: HTMLProps<HTMLElement>['className'];
  onPress: () => void;
  iconColor?: string;
};

// TODO: this can probably be made into a variant of the main button
export const HeaderButton = ({
  title,
  className,
  onPress,
  iconColor,
}: HeaderButtonProps) => {
  const theme = useTheme();

  return (
    <Pressable
      onPress={onPress}
      className={cn('flex-row items-center active:opacity-20', className)}>
      <Heading level={5} className="text-primary mr-1">
        {title}
      </Heading>
      <DropdownIcon stroke={iconColor ?? theme.primary} />
    </Pressable>
  );
};
